module.exports = __webpack_public_path__ + "img/new-real-estate-4.8cdb1208.jpg";